import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'

import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify'

import './styles/index.scss'

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <React.StrictMode>
    <ToastContainer />
    <App />
  </React.StrictMode>
)
